<div class="message-text mb-2">
  <div class="d-flex align-items-center justify-content-center">
    <div class="col-1">
      <mat-icon class="message-icon">info</mat-icon>
    </div>
    <div class="col-10">
      <div class="ms-1" [innerHTML]="message | async"></div>
    </div>
    <div class="col-md-1">
      <button mat-icon-button color="accent" (click)="dismiss()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>